<template>
  <v-container fluid>
    <h2 class="page-title mb-1">Solicitudes ARCO+</h2>
    <p class="page-desc mb-4">
      Revisión de solicitudes de oposición (Ley 21.719) que quedaron pendientes de
      revisión manual, y su historial de resolución.
    </p>

    <OppositionRequestsTable />
  </v-container>
</template>

<script>
import OppositionRequestsTable from '@/components/OppositionRequestsTable.vue';

export default {
  name: 'OppositionRequests',
  components: { OppositionRequestsTable }
};
</script>

<style scoped>
.page-title {
  color: #104b94;
  font-weight: 700;
}
.page-desc {
  font-size: 13px;
  color: #555;
  max-width: 760px;
}
</style>
